import { PartnerType } from "@debitroom-software/types";
import { NavigationGuardNext, RouteLocationNormalized } from "vue-router";

import { useAuthorisationStore } from "@/modules/authorisation/authorisationStore";

export default async function checkPartnerType(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) {
  const authorisationStore = useAuthorisationStore();
  await authorisationStore.fetchProfileInformation();

  if (!authorisationStore.profile?.partnerTypes.includes(PartnerType.Funding)) {
    return next({ name: "financeReceivers.table" });
  }

  return next({ name: "funders.table" });
}
